import React from 'react';
import { colors } from './constants';
import BedCard from './BedCard';

const BedGrid = ({ 
  currentWard, 
  beds, 
  filteredBeds, 
  selectedBeds, 
  hoveredBed, 
  setHoveredBed, 
  handleBedClick, 
  handleBedRightClick 
}) => {
  const styles = {
   bedGrid: {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fill, minmax(100px, 1fr))",
  gap: "12px",
  justifyItems: "center",
  alignItems: "center",
  width: "100%",
  padding: "10px 0",
},
bedRow: {
  display: "contents", // allow direct placement into grid
},

    fallbackGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(120px, 1fr))',
      gap: '12px',
      marginTop: '20px'
    },
    emptyState: {
      padding: '48px 24px',
      textAlign: 'center',
      color: colors.slate500,
      fontSize: '14px'
    },
    wardInfo: {
      background: 'rgba(33, 128, 141, 0.08)',
      border: `1px solid rgba(33, 128, 141, 0.2)`,
      borderRadius: '8px',
      padding: '12px 16px',
      marginBottom: '16px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      fontSize: '13px'
    }
  };

  // Show empty state if no beds
  if (!filteredBeds || filteredBeds.length === 0) {
    return (
      <div style={styles.emptyState}>
        <p>No beds found in this ward.</p>
        <p style={{ fontSize: '12px', marginTop: '8px' }}>
          Click "Bed Management" to add beds to this ward.
        </p>
      </div>
    );
  }

  // Display ward pricing info if available
  const showWardInfo = currentWard?.dailyFare || currentWard?.depositAmount;

  return (
    <> 
      {showWardInfo && (
        <div style={styles.wardInfo}>
          <div>
            <strong>{currentWard?.name || 'Current Ward'}</strong>
            <span style={{ marginLeft: '12px', color: colors.slate500 }}>
              {currentWard?.department || ''}
            </span>
          </div>
          <div style={{ display: 'flex', gap: '16px' }}>
            {currentWard?.dailyFare && (
              <span>
                <strong>Daily:</strong> ₹{currentWard.dailyFare}
              </span>
            )}
            {currentWard?.depositAmount && (
              <span>
                <strong>Deposit:</strong> ₹{currentWard.depositAmount}
              </span>
            )}
          </div>
        </div>
      )}

  
      {currentWard?.layout && currentWard.layout.length > 0 ? (
  <div style={styles.bedGrid}>
    {currentWard.layout.map((row, rowIndex) => (
      <div key={rowIndex} style={styles.bedRow}>
        {row.map(bedId => {
          const bed = filteredBeds.find(b => b.id === bedId);
          if (!bed) return null;
          
          return (
            <BedCard 
              key={bed.id}
              bed={bed}
              isHovered={hoveredBed?.id === bed.id}
              selectedBeds={selectedBeds}
              onClick={() => handleBedClick(bed)}
              onRightClick={(e) => handleBedRightClick(e, bed)}
              onMouseEnter={() => setHoveredBed(bed)}
              onMouseLeave={() => setHoveredBed(null)}
            />
          );
        })}
      </div>
    ))}

    {/* Render any extra beds not present in layout (newly added dynamic beds) */}
    {filteredBeds
      .filter(b => {
        const layoutIds = currentWard.layout.flat();
        return !layoutIds.includes(b.id);
      })
      .map(bed => (
        <div key={bed.id} style={{ ...styles.bedRow, marginTop: 8 }}>
          <BedCard 
            bed={bed}
            isHovered={hoveredBed?.id === bed.id}
            selectedBeds={selectedBeds}
            onClick={() => handleBedClick(bed)}
            onRightClick={(e) => handleBedRightClick(e, bed)}
            onMouseEnter={() => setHoveredBed(bed)}
            onMouseLeave={() => setHoveredBed(null)}
          />
        </div>
      ))}
  </div>
) : (
  // fallback unchanged
  <div style={styles.fallbackGrid}>
    {filteredBeds.map(bed => (
      <BedCard 
              key={bed.id}
              bed={bed}
              isHovered={hoveredBed?.id === bed.id}
              selectedBeds={selectedBeds}
              onClick={() => handleBedClick(bed)}
              onRightClick={(e) => handleBedRightClick(e, bed)}
              onMouseEnter={() => setHoveredBed(bed)}
              onMouseLeave={() => setHoveredBed(null)}
            />
    ))}
  </div>
)}

    </>
  );
};

export default BedGrid;
